export default {
  patients: 'patients',
  storage: 'storage',
  order: 'order',
} as const
